class SideMenuComponent extends HTMLElement {
  constructor() {
    super();
    this.menuToggle = null;
    this.menuClose = null;
    this.mobileMenu = null;
    this.overlay = null;
    this.minuterie = null;
  }

  connectedCallback() {
    this.menuToggle = this.querySelector('[data-ref="sidebar-toggle"]');
    this.menuClose = this.querySelector('[data-ref="sidebar-close"]');
    this.mobileMenu = this.querySelector('[data-ref="sidebar-menu"]');
    this.overlay = this.querySelector('[data-ref="sidebar-overlay"]');

    this.menuToggle?.addEventListener('click', this.#handleMenuOpen);

    this.menuClose?.addEventListener('click', this.#handleMenuClose);

    this.overlay?.addEventListener('click', this.#handleOverlayClick);

    document.addEventListener('keydown', this.#handleKeyDown);

    // 08/09 : au retour par le bouton precedent, la page peut etre restituee
    // depuis le cache avec le panneau encore ouvert. On garantit l'etat ferme
    // a l'affichage, sans animation ni minuterie.
    window.addEventListener('pageshow', this.#fermerDur);
  }

  disconnectedCallback() {
    this.menuToggle?.removeEventListener('click', this.#handleMenuOpen);

    this.menuClose?.removeEventListener('click', this.#handleMenuClose);

    this.overlay?.removeEventListener('click', this.#handleOverlayClick);

    document.removeEventListener('keydown', this.#handleKeyDown);

    window.removeEventListener('pageshow', this.#fermerDur);

    if (this.minuterie) {
      clearTimeout(this.minuterie);
      this.minuterie = null;
    }
  }

  #handleMenuOpen = () => {
    this.open();
  };

  #handleMenuClose = () => {
    this.close();
  };

  #handleOverlayClick = (event) => {
    // Fermer le menu si on clique sur l'overlay (pas sur le menu lui-même)
    if (event.target === this.overlay) {
      this.close();
    }
  };

  #handleKeyDown = (event) => {
    // Fermer le menu avec la touche Escape
    if (event.key === 'Escape' && this.overlay?.classList.contains('is-open')) {
      this.close();
    }
  };

  /* 08/09 : l'etat ferme ne doit dependre d'aucune animation ni d'aucun
     evenement de fin de transition. Cette methode remet l'etat a plat et
     peut etre appelee autant de fois qu'on veut. */
  #fermerDur = () => {
    if (this.minuterie) {
      clearTimeout(this.minuterie);
      this.minuterie = null;
    }
    this.overlay?.classList.remove('is-open', 'is-closing');
    document.body.classList.remove('overflow-hidden');
  };

  open() {
    if (!this.overlay) return;
    // Une ouverture annule une fermeture en cours, sinon la minuterie de
    // fermeture refermerait le panneau qu'on vient d'ouvrir.
    if (this.minuterie) {
      clearTimeout(this.minuterie);
      this.minuterie = null;
    }
    this.overlay.classList.remove('is-closing');
    this.overlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');

    // Focus sur le bouton de fermeture pour l'accessibilité
    setTimeout(() => {
      this.menuClose?.focus();
    }, 150);
  }

  close() {
    if (!this.overlay) return;

    // Fermeture deja en cours ou panneau deja ferme : on va droit a l'etat
    // ferme au lieu d'empiler une seconde minuterie.
    if (this.minuterie || !this.overlay.classList.contains('is-open')) {
      this.#fermerDur();
      this.menuToggle?.focus();
      return;
    }

    // Le deverrouillage du defilement ne doit pas attendre l'animation : si
    // la minuterie est etranglee, la page resterait bloquee.
    document.body.classList.remove('overflow-hidden');

    // La classe de fermeture ne sert plus qu'a l'animation de sortie du
    // panneau lui-meme.
    this.overlay.classList.add('is-closing');

    this.minuterie = setTimeout(() => {
      this.minuterie = null;
      this.overlay?.classList.remove('is-open', 'is-closing');
      document.body.classList.remove('overflow-hidden');

      // Remettre le focus sur le bouton menu
      this.menuToggle?.focus();
    }, 125); // Durée légèrement inférieure à --animation-speed pour éviter les décalages
  }
}

if (!customElements.get('side-menu-component')) {
  customElements.define('side-menu-component', SideMenuComponent);
}
